import { Link } from 'react-router-dom';
import { Icon, type IconName } from '../../components/ui/Icon';
import './dashboard.css';

export type StatTone = 'primary' | 'info' | 'success' | 'warning';

interface StatTileProps {
  label: string;
  value: string;
  icon: IconName;
  tone: StatTone;
  /** Optional secondary line under the label (e.g. a per-platform split). */
  hint?: string;
  /**
   * Optional drill-down, rendered as the tile footer. A value starting with
   * '#' is a same-page anchor and renders a plain <a> so the browser scrolls
   * natively; anything else is a router Link.
   */
  to?: string;
  linkLabel?: string;
}

/**
 * Headline KPI tile: filled tone, oversized value, and a drill-down footer.
 * The background icon is decorative — the value and label carry the meaning.
 */
export function StatTile({ label, value, icon, tone, hint, to, linkLabel }: StatTileProps) {
  return (
    <article className={`dash-stat dash-stat--${tone}`}>
      <Icon name={icon} className="dash-stat__glyph" />
      <p className="dash-stat__value">{value}</p>
      <p className="dash-stat__label">{label}</p>
      {hint ? <p className="dash-stat__hint">{hint}</p> : null}
      {to && linkLabel ? (
        to.startsWith('#') ? (
          <a className="dash-stat__link" href={to}>
            {linkLabel}
            <Icon name="arrowRight" className="dash-stat__link-icon" />
          </a>
        ) : (
          <Link className="dash-stat__link" to={to}>
            {linkLabel}
            <Icon name="arrowRight" className="dash-stat__link-icon" />
          </Link>
        )
      ) : null}
    </article>
  );
}
